import { render, staticRenderFns } from "./ISAMigrationModal.vue?vue&type=template&id=87f77fd4&"
import script from "./ISAMigrationModal.vue?vue&type=script&lang=js&"
export * from "./ISAMigrationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports